import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fundraising-program',
  templateUrl: './fundraising-program.component.html',
  styleUrls: ['./fundraising-program.component.scss']
})
export class FundraisingProgramComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  scrollToForm(idSelector: string): void {
    document.getElementById(idSelector).scrollIntoView({'behavior':'smooth'});
  }

}



// WEBPACK FOOTER //
// ./src/app/fundraising-program/fundraising-program.component.ts